// MOTUS — beacon analytics du drawer filtre.
// Regroupe les événements par batch (flush toutes les 4s + au unload).
// Compatible sendBeacon, replie sur fetch keepalive sinon.
// AUCUNE donnée personnelle, AUCUN cookie, AUCUNE IP côté client (le
// serveur n'en stocke pas non plus). Le seul contexte transmis :
// {type, cle, collection}.
(function () {
  "use strict";

  var script = document.currentScript;
  var meta = document.querySelector('meta[name="motus-filtres-collecte"]');
  var ENDPOINT = (meta && meta.getAttribute("content")) || "";
  var COLLECTION =
    (script && script.getAttribute("data-collection")) ||
    (document.body && document.body.getAttribute("data-collection")) ||
    null;

  // Garde placeholder : tant que shop.metafields.motus.collecte_url n'est
  // pas configuré, le snippet Liquid rend "MOTUS_COLLECTE_URL_NON_CONFIGUREE"
  // et le beacon reste silencieux. Aucune requête sortante, aucun bruit
  // dans la console, aucune erreur pour la cliente.
  if (
    !ENDPOINT ||
    ENDPOINT === "MOTUS_COLLECTE_URL_NON_CONFIGUREE" ||
    ENDPOINT.indexOf("http") !== 0
  ) {
    return;
  }

  var queue = [];
  var flushing = false;

  function flush() {
    if (flushing || queue.length === 0) return;
    var batch = queue.splice(0, 20);
    var body = JSON.stringify({ events: batch });
    flushing = true;
    var sent = false;
    if (navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: "application/json" });
        sent = navigator.sendBeacon(ENDPOINT, blob);
      } catch (e) {
        sent = false;
      }
    }
    if (!sent) {
      try {
        fetch(ENDPOINT, {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: body,
          keepalive: true,
          credentials: "omit",
          mode: "cors",
        }).catch(function () {});
      } catch (e) {
        // silent
      }
    }
    flushing = false;
  }

  function push(type, cle) {
    if (!type) return;
    queue.push({ type: type, cle: cle || null, collection: COLLECTION });
    if (queue.length >= 15) flush();
  }

  setInterval(flush, 4000);
  window.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") flush();
  });
  window.addEventListener("pagehide", flush);
  window.addEventListener("beforeunload", flush);

  // Détection auto : les drawers Shopify (Dawn / Impact / OS 2 stores) posent
  // des attributs data-motus-* sur les inputs. Le snippet drawer les ajoute.
  document.addEventListener("click", function (ev) {
    var el = ev.target;
    if (!(el instanceof Element)) return;
    var trigger = el.closest("[data-motus-event]");
    if (!trigger) return;
    var type = trigger.getAttribute("data-motus-event");
    var cle = trigger.getAttribute("data-motus-cle");
    push(type, cle);
  });

  // Ouverture du drawer : la balise wrapper porte data-motus-drawer.
  document.addEventListener("motus-filtres:ouverture", function () {
    push("OUVERTURE", null);
  });

  // Ré-écoute si le thème utilise un event pubsub Shopify.
  document.addEventListener("shopify:section:load", function () {
    // Rien à faire — les nouveaux boutons rentreront via le listener global.
  });

  // Expose une API mini pour intégration manuelle si besoin.
  window.MotusFiltres = {
    envoyer: push,
    flush: flush,
  };
})();
